import React from "react"
import Charts from "../../util/util"
import echarts from "echarts"

export default class Donut extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: Math.round(Math.random() * 10000000),
    }
  }
  componentDidMount() {
    this.initProps(this.props)
  }
  initProps(props) {
    let { name, value = 0, color = "#54D2E2" } = props
    let id = this.getId()
    let option = {
      tooltip: {
        trigger: "item",
        formatter: "{b} : {c} ({d}%)",
      },
      // legend: {
      //   orient: "vertical",
      //   top: "8%",
      //   left: "center",
      //   data: [name],

      // },
      series: [
        {
          type: "pie",
          radius: ["80%", "90%"],
          label: {
            normal: {
              position: "center",
            },
          },
          data: [
            {
              value: value,
              name: name,
              label: {
                normal: {
                  formatter: "{d} %",
                  textStyle: {
                    fontSize: 18,
                  },
                },
              },
              itemStyle: {
                normal: {
                  color: color,
                },
              },
            },
            {
              value: 100 - value,
              label: {
                normal: {
                  formatter: "\n" + name,
                  textStyle: {
                    color: "#F7F7FF",
                    fontSize: 18,
                  },
                },
              },
              tooltip: {
                show: false,
              },
              itemStyle: {
                normal: {
                  color: "#343357",
                },
                emphasis: {
                  color: "#343357",
                },
              },
              hoverAnimation: false,
            },
          ],
        },
      ],
    }

    var chart = this["_" + id]
    if (!chart) {
      chart = this["_" + id] = echarts.init(document.getElementById(id))
      Charts.registerChartsResize(chart)
    }
    chart.setOption(option)
  }
  componentWillReceiveProps(props) {
    this.initProps(props)
  }
  componentWillUnmount() {
    let id = this.getId()
    Charts.destroyCharts(this["_" + id])
  }

  getId() {
    return "ct_pie_" + this.state.id
  }

  render() {
    return <div id={this.getId()} style={{ height: "100%" }} />
  }
}
